import { render, staticRenderFns } from "./CreateEditArchiveAndDocument.vue?vue&type=template&id=53d90593"
import script from "./CreateEditArchiveAndDocument.vue?vue&type=script&lang=js"
export * from "./CreateEditArchiveAndDocument.vue?vue&type=script&lang=js"
import style0 from "./CreateEditArchiveAndDocument.vue?vue&type=style&index=0&id=53d90593&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports